// The Moon's streamed surface: the LROC WAC mosaic through the same streamer
// the Earth uses (planetimagery.js), and the LOLA heights under the vessel
// (moondem.js). The flight adapter is moonsurface.js.
//
// Imagery tiles are 512 px, level L covering 180 / 2^L degrees: L1 is the
// root (4 x 2), L5 the page table (64 x 32 pages of 5.6 degrees), L7 the
// finest (1456 px/deg, 21 m per pixel), sixteen detail cells per page. The
// layer is the albedo colour built by scripts/planet-tile-cache.mjs (Moon Kit
// colour, Kaguya TC detail); the terrain shader calibrates it to normal albedo.
import { createPlanetImagery } from './planetimagery.js';
import { RUNNING_ON_MOBILE } from '../mobiledevice.js';
import { MOON_ALBEDO_PATH, MOON_ALBEDO_CACHE, MOON_ALBEDO_MAX_LEVEL, MOON_RADIUS, moonTcSourceTiles } from '../data/moonImagerySource.js';

// On static hosting a tile the project did not ship (L5-L9) falls back to the
// raw Kaguya TC mosaic, composited in the browser from its four Moon Trek
// tiles (CORS is open there): right detail, grey instead of the Kit's colour.
async function fetchTrekComposite(tile, signal) {
  const urls = moonTcSourceTiles(tile.z, tile.x, tile.y);
  const bitmaps = await Promise.all(urls.map(async u => {
    const res = await fetch(u, { signal, mode: 'cors' });
    if (!res.ok) throw new Error('Moon Trek ' + res.status);
    return createImageBitmap(await res.blob());
  }));
  const canvas = new OffscreenCanvas(512, 512);
  const g = canvas.getContext('2d');
  bitmaps.forEach((b, i) => { g.drawImage(b, (i % 2) * 256, Math.floor(i / 2) * 256, 256, 256); b.close(); });
  const blob = await canvas.convertToBlob({ type: 'image/jpeg', quality: 0.92 });
  return new Response(blob, { status: 200, headers: { 'content-type': 'image/jpeg' } });
}

export const moon = createPlanetImagery({
  name: 'moon', radius: MOON_RADIUS, tileSize: 512, rootSpan: 180, rootLevel: 1, pageLevel: 5, maxLevel: MOON_ALBEDO_MAX_LEVEL,
  // A phone's smaller atlas, as the Earth's (earthimagery.js).
  ...(RUNNING_ON_MOBILE ? { atlasSide: 6, maxBudget: 20 } : {}),
  cacheName: MOON_ALBEDO_CACHE,
  localUrl: (z, x, y) => `${MOON_ALBEDO_PATH}/${z}/${y}/${x}.jpg`,
  url: (z, x, y) => moonTcSourceTiles(z, x, y)[0],
  fetchRemote: fetchTrekComposite
});
export const moonImageryUniforms = moon.uniforms;
export const MOON_IMAGERY_GLSL = moon.glsl;
export const getMoonImageryStream = moon.getStream;

